<div class="white_paper_wrap">
    <div class="paper_top_sections">
        <h1>Trinka與Grammarly、LanguageTool在學術文件上的比較</h1>
    </div>

    <div class="need_whitePaper_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="need_content_text">
                        <h2>為什麼需要此白皮書？</h2>
                        <p>一般英語有幾種文法檢查工具，但很少專門針對學術英語寫作、術語、科學慣例以及與出版準備相關的問題。</p>

                        <p>深入閱讀本白皮書將使您能夠在評估和使用寫作助手、文法檢查工具和語言糾正工具時做出最明智的決定，以用於您的個人、專業、學術或技術寫作。</p>

                        <p>本白皮書將為您提供準確的理解和資料支援，讓您瞭解Trinka為什麼最適合學術寫作。這是因為它在準確性、覆蓋率以及專門用於出版物準備就緒的功能之間取得了很好的平衡。</p>
                        <div class="download_whitePaper text-center">
                            <a id="downloadThisWhitePaper" href="../../../assets/resources/Trinka_WhitePaper.pdf" download="trinka-vs-grammarly-vs-language-tool">
                                <img src="../../../assets/images/whitePaper_download.png" alt="whitepaper download">下載此白皮書</a>
                        </div>
                        <div class="key_takewaye_sections">
                            <h2>要點</h2>
                            <div class="row">
                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>1</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>全球作家、作者和專業學術作家的特定痛點。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>2</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>當前可用的寫作助手的可操作性和局限性。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>3</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>Trinka、Grammarly以及LanguageTool的簡要比較。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>4</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>Trinka勝過所有其他寫作助手。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="sneak_peek_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="sneak_heading">
                        <h2>瞭解一下本白皮書</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="whitePaper_slider testimonials">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="center">

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="trinka comparison">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar slide">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="trinka comparison">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar slide">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="trinka comparison">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="trinka comparison">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar slide">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="trinka comparison">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar slide">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/comparison_slide.png" alt="trinka comparison">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/summary_slide.png" alt="summary slide">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="../../../assets/images/Grammar_slide.png" alt="grammar slide">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="container">

            <div class="row">
                <div class="col-sm-12">
                    <div id="customers-testimonials" class="owl-carousel">
                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="../../../assets/images/whitePaperSlide_02.png" alt="">
                            </div>
                        </div>

                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="../../../assets/images/WhitePaperSlider_01.png" alt="">
                            </div>
                        </div>
                        
                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="../../../assets/images/WhitePaperSlider_03.png" alt="">
                            </div>
                        </div>
                        
                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="../../../assets/images/whitePaperSlide_02.png" alt="">
                            </div>
                        </div>

                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="../../../assets/images/WhitePaperSlider_01.png" alt="">
                            </div>
                        </div>
                        
                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="../../../assets/images/WhitePaperSlider_03.png" alt="">
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div> -->
    </section>

    <!-- <div class="whtiePaper_sections">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="WhitePaper_cards slicer_changes">
                        <div class="overlay_whitepaper"></div>
                        <img src="../../../assets/images/WhitePaperSlider_01.png" alt="">
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="WhitePaper_cards">
                        <img src="../../../assets/images/whitePaperSlide_02.png" alt="">
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="WhitePaper_cards slicer_changes">
                        <div class="overlay_whitepaper"></div>
                        <img src="../../../assets/images/WhitePaperSlider_03.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="bottomSilderButtons">
        <div class="download_whitePaper text-center">
            <a id="downloadThisWhitePaperFooter" href="../../../assets/resources/Trinka_WhitePaper.pdf" download="trinka-vs-grammarly-vs-language-tool">
                <img src="../../../assets/images/whitePaper_download.png" alt="whitepaper download">
                下載此白皮書</a>
        </div>
    </div>
</div>